import React from 'react'
import {
  IoIosStar as StarFilled,
  IoIosStarOutline as StarOutline,
} from 'react-icons/io'
import { i18nTranslate } from 'src/utils'
import isFunction from 'lodash/isFunction'

class Ratings extends React.PureComponent {
  static defaultProps = {
    starCount: 5,
    starRating: 5,
  }

  renderRatings = (startRating, starCount) => {
    const stars = []
    const emptyStarCount = starCount - startRating

    for (let index = 0; index < startRating; index++) {
      const ratingsView = (
        <StarFilled
          className="text-primary"
          size="1.5rem"
          key={`star-rating-icon-${index}`}
          {...(isFunction(this.props.handleClick) && {
            onClick: () => this.props.handleClick(index, 'fill'),
          })}
          aria-label={i18nTranslate('icons.filledStar', 'Star Ratings', {
            nameSpace: 'ssr-resource',
          })}
        />
      )
      stars.push(ratingsView)
    }

    for (let index = 0; index < emptyStarCount; index++) {
      const ratingsView = (
        <StarOutline
          size="1.5rem"
          {...(isFunction(this.props.handleClick) && {
            onClick: () => this.props.handleClick(index),
          })}
          key={`star-rating-icon-border-${index}`}
          aria-label={i18nTranslate('icons.emptyStar', 'Star Ratings Outline', {
            nameSpace: 'ssr-resource',
          })}
        />
      )
      stars.push(ratingsView)
    }
    return stars
  }

  render() {
    const { starRating, starCount } = this.props
    const ratings = this.renderRatings(starRating, starCount)
    return <>{ratings}</>
  }
}

export default Ratings
export { Ratings }
